import { Button, ButtonProps, Modal, useOverlayState, Spinner } from "@heroui/react";

export type ConfirmModalProps = {
    trigger?: React.ReactElement,
    buttonTitle?: React.ReactElement | string,
    buttonProps?: ButtonProps,
    title: string,
    body: React.ReactElement,
    /** 成功 resolve 后自动关闭弹窗；reject/throw 则保持打开（错误提示由业务处理） */
    onConfirm: () => void | Promise<void>,
    loading?: boolean,
}

export const ComponentComfirm = (props: ConfirmModalProps) => {
    const state = useOverlayState();

    const handleConfirm = async () => {
        try {
            await Promise.resolve(props.onConfirm());
            state.close();
        } catch {
            // 保留对话框
        }
    };

    return (
        <>
            {props.trigger ? (
                <span onClick={state.open}>
                    {props.trigger}
                </span>
            ) : (
                <Button {...props.buttonProps} onPress={state.open}>
                    {props.buttonTitle}
                </Button>
            )}
            <Modal.Backdrop isOpen={state.isOpen} onOpenChange={state.setOpen}>
                <Modal.Container>
                    <Modal.Dialog>
                        {({ close }) => (
                            <>
                                <Modal.Header>
                                    <Modal.Heading>{props.title}</Modal.Heading>
                                </Modal.Header>
                                <Modal.Body>
                                    {props.body}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        className="bg-primary text-white rounded-full"
                                        onPress={() => void handleConfirm()}
                                        isPending={props.loading}
                                    >
                                        {({ isPending }) => (
                                            <>
                                                {isPending && <Spinner size="sm" color="current" />}
                                                确认
                                            </>
                                        )}
                                    </Button>
                                    <Button className="bg-gray-100 text-[#333333] rounded-full" onPress={close} isDisabled={props.loading}>取消</Button>
                                </Modal.Footer>
                            </>
                        )}
                    </Modal.Dialog>
                </Modal.Container>
            </Modal.Backdrop>
        </>
    );
};
